<%= form_with(model: region, class: "contents") do |form| %>
  <% if region.errors.any? %>
    <div id="error_explanation" class="bg-red-50 text-red-500 px-3 py-2 font-medium rounded-md mt-3">
      <h2><%= pluralize(region.errors.count, "error") %> prohibited this region from being saved:</h2>

      <ul class="list-disc ml-6">
        <% region.errors.each do |error| %>
          <li><%= error.full_message %></li>
        <% end %>
      </ul>
    </div>
  <% end %>

  <div class="my-5">
    <%= form.label :code %>
    <%= form.text_field :code, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": region.errors[:code].none?, "border-red-400 focus:outline-red-600": region.errors[:code].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :type %>
    <%= form.text_field :type, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": region.errors[:type].none?, "border-red-400 focus:outline-red-600": region.errors[:type].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :location %>
    <%= form.text_field :location, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": region.errors[:location].none?, "border-red-400 focus:outline-red-600": region.errors[:location].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :latitude %>
    <%= form.text_field :latitude, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": region.errors[:latitude].none?, "border-red-400 focus:outline-red-600": region.errors[:latitude].any?}] %>
  </div>

  <div class="my-5">
    <%= form.label :longitude %>
    <%= form.text_field :longitude, class: ["block shadow-sm rounded-md border px-3 py-2 mt-2 w-full", {"border-gray-400 focus:outline-blue-600": region.errors[:longitude].none?, "border-red-400 focus:outline-red-600": region.errors[:longitude].any?}] %>
  </div>

  <div class="inline">
    <%= form.submit class: "w-full sm:w-auto rounded-md px-3.5 py-2.5 bg-blue-600 hover:bg-blue-500 text-white inline-block font-medium cursor-pointer" %>
  </div>
<% end %>
